import { isRealNameDecide, getTempInfo, urlAllBase, syncAddUserInfo, setStorage, tokenTime } from '../../common.js';
import { Toast } from 'antd-mobile/lib';
import Util from '../../util.js';
import { getUserInfoList } from "../loginAction.js";
import { hashHistory } from 'react-router';


//实名个人信息
export function verifiedUserInfo(text) {
  return {
    type: "VERIFIEDUSERINFO",
    text: text
  }
}

//未实名个人信息
export function unVerifiedUserInfo(text) {
  return {
    type: "UNVERIFIEDUSERINFO",
    text: text
  }
}


//上传私募投资资料
export function uploadPrivateData(text) {
  return {
    type: "UPLOAD_PRIVATE_DATA",
    text: text
  }
}
//私募投资者资料上传情况
export function checkPrivate(text) {
  return {
    type: "CHECK_PRIVATE",
    text: text
  }
}
//私募投资者资料上传情况（资管）
export function checkPrivateZg(text) {
  return {
    type: "CHECK_PRIVATE_ZG",
    text: text
  }
}

//私募投资者状态
export function userIsPrivate(text) {
  return {
    type: "USER_IS_PRIVATE",
    text: text
  }
}
//私募投资者状态(资管)
export function userIsPrivateZg(text) {
  return {
    type: "USER_IS_PRIVATE_ZG",
    text: text
  }
}

//银行卡类型
export function bankType(text) {
  return {
    type: "BANK_TYPE",
    text: text
  }
}

//获取流水号
export function checkNumber(text) {
  return {
    type: "CHECK_NUMBER",
    text: text
  }
}
//鉴权确认
export function checkSuccessData(text) {
  return {
    type: "CHECK_SUCCESS_DATA",
    text: text
  }
}

//实名认证创建交易账号
export function certifcationSuccess(text) {
  return {
    type: "CERTIFCATION_SUCCESS",
    text: text
  }
}
//实名认证职业列表
export function userJob(text) {
  return {
    type: "USER_JOB",
    text
  }
}

//实名认证城市列表
export function provinceCity(text) {
  return {
    type: "PROVINCE_CITY",
    text: text
  }
}
//投资者资料审核情况
export function checkPrivateData(type) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == null) {
        token = "";
      }
      fetch(Util.url + "/api/account/validateHasUploadFile?token=" + token + "&provedType=" + type)
        .then((response) => response.json())
        .then((responseText) => {
          if(responseText.code == "0000") {
            if(type == "0") {
              dispatch(checkPrivate(responseText.content));
            }else {
              dispatch(checkPrivateZg(responseText.content));
            }
            console.log("投资者资料审核情况");
            console.log(responseText);
          }else {
            console.log(responseText.code);
            Toast.info( responseText.code, 2);
          }
        })
        .catch(function(err){
          console.log("错误信息" + err);
          Toast.info( "网络异常，请检查您的网络", 2);
        });
    });
  }
}

//上传私募投资者资料
export function getUploadPrivateData(files, callback, type) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == null) {
        token = "";
      }
      fetch(Util.url + "/asset/account/uploadAssetProved?token=" + token + "&provedType=" + type, {
        mode:"cors",
        method:'POST',  
        body:files
      })
      .then((response) => response.json())
      .then((responseText) => {
        if(responseText.code == "0000") {
          Toast.hide();
          dispatch(uploadPrivateData(responseText));
          Toast.info( "上传成功，请等待审核", 2);
          if(type == "0") {
            dispatch(checkPrivate(false));
            console.log("上传私募投资者资料");
          }else {
            dispatch(checkPrivateZg(false));
            console.log("上传私募资管投资者资料");
          }
          dispatch(checkPrivateData(type));
          hashHistory.goBack();
          console.log("上传私募投资者资料");
          console.log(responseText);
          if(callback) {
            callback
          }
        }else {
          console.log(responseText.code);
          // Toast.info( responseText.code, 2);
          Toast.info(responseText.code,)
        }
      })
      .catch(function(err){
        console.log(err);
       Toast.info( "网络异常，请检查您的网络", 1);
      });
    });
  }
}

//编辑虚拟用户个人信息
export function updateUnUserInfo(thisO,nickName) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == null) {
        token = "";
      }
      fetch(Util.url + "/api/account/modifyNickName?newNickName=" + nickName + "&token=" + token)
      .then((response) => response.json())
      .then((responseText) => {
        if(responseText.code == "0000") {
          // dispatch(provinceCity(responseText.content));
          console.log("编辑虚拟用户个人信息");
          console.log(responseText);
        }else {
          console.log( responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
          thisO.setState({
            flag: false
          });
        }
      })
      .catch(function(err){
        console.log("错误信息" + err);
        Toast.info( "网络异常,请检查您的网络", Util.ToastTime);
        thisO.getState({
          flag:false
        });
      });
    });
  }
}

//保存控制人受益人身份证信息
export function saveUserAccount(params){
  return function(dispatch, getState) {
    console.log(params);
    Util.get(Util.url+"/api/camchqtaccount/modifyUserAccountInfo",params,function(res){
      console.log(res);
      if(res.code == "0000"){

      }else{
        
      }
    },function(error){
      console.log(error)
    })
  }
}


//获取控制人受益人上传id
export function getConversationIds(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      // params.token = data;
      Util.get(Util.url+"/api/certificate/getConversationIds", params, function(responseText){   
        if(responseText.code == "0000"){
          console.log(responseText)
          callback(responseText);
        }else{
          console.log(responseText);
          errBack();
          Toast.info(responseText.code );
        }
      }, function(err){
        errBack();
        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
    });
  }
}


//上传身份证图片
export function uploadCertificatePic(data, callback, errBack, flag, RoleVal) {
  return function(dispatch, getState) {
    data.append("accountRole", RoleVal);
    console.log(data)
    fetch(Util.url + "/api/certificate/uploadCertificatePicAml", {
      mode:"cors",
      method:'POST',  
      body:data
    })
    .then((response) => response.json())
    .then((responseText) => {
      console.log(responseText)
      if(flag) {
        if(responseText.code == "0000") {
          callback(responseText);
          console.log(responseText);
        }else {
          errBack();
          Toast.info(responseText.code,2);
          console.log(responseText.code);
        }
      }else {
        if(responseText) {
          var isjson = typeof(responseText) == "object" && Object.prototype.toString.call(responseText).toLowerCase() == "[object object]" && !responseText.length; 
          if(isjson) {
            if(responseText.code == "0000") {
              if(responseText.content && responseText.content.requestId) {
                callback(responseText);
                console.log(responseText);
              }else {
                //非法篡改requestId
                errBack();
                Toast.info("上传身份证照片失败,请重新上传",2);
              }
            }else {
              errBack();
              Toast.info(responseText.code,2);
              console.log(responseText.code);
            }
          }else {
            //非法篡改requestId
            errBack();
            Toast.info("上传身份证照片失败,请重新上传",2);
          }
        }else {
          //非法篡改requestId
          errBack();
          Toast.info("上传身份证照片失败,请重新上传",2);
        }
      }
    })
    .catch(function(err){
      errBack();
      console.log(err);
    });
  }
}

//编辑实名用户个人信息
export function updateUserInfo(thisO, params, data) {
  console.log("+++++");
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == null) {
        token = "";
      }
      fetch(Util.url + "/api/account/modifyAccountInfo?" + params + "=" + data + "&token=" + token)
              .then((response) => response.json())
      .then((responseText) => {
        if(responseText.code == "0000") {
          // dispatch(provinceCity(responseText.content));
          console.log("编辑实名用户个人信息");
          console.log(responseText);
        }else {
          console.log( responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
          thisO.setState({
            flag: false
          });
        }
      })
      .catch(function(err){
        console.log("错误信息" + err);
        Toast.info( "网络异常,请检查您的网络", Util.ToastTime);
        thisO.getState({
          flag:false
        });
      });
    });
  }
}

//活期通打通
//获取用户可开通活期通的银行卡列表
export function getCardByHqt(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/camchqtaccount/findOtsOpenPaymentChannelList", params, function(responseText){   
        if(responseText.code == "0000"){
          let newData = responseText.content;
          for(let i = 0; i < newData.length; i++) {
            if(newData[i].bankCode == "007" && newData[i].paymentChannelId == "G000") {
              newData.splice(i, 1);
            }
          }
          callback(newData);
          console.log(responseText)
        }else{
          errBack();
          console.log(responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
        }
      }, function(err){
        errBack();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
    });
  }
}

//获取用户活期通开户的银行卡列表
export function getCardByHqtOpen(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      Util.get(Util.url+"/api/camchqtaccount/openAccountBankList", params, function(responseText){   
        if(responseText.code == "0000"){
          let newData = responseText.content;
          for(let i = 0; i < newData.length; i++) {
            if(newData[i].bankCode == "007" && newData[i].paymentChannelId == "G000") {
              newData.splice(i, 1);
            }
          }
          callback(newData);
          console.log(responseText)
        }else{
          errBack();
          console.log(responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
        }
      }, function(err){
        errBack();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);
        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
    });
  }
}

//获取用户在财富的银行卡列表
export function getCardListByCf(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/paymentaccount/getCardList", params, function(responseText){   
        if(responseText.code == "0000"){
          callback(responseText.content.bankCard);
          console.log(responseText)
        }else{
          errBack();
          console.log(responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
        }
      }, function(err){
        errBack();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);   
    });
  }
}

//活期通加卡鉴权申请
export function addCardByHqtPost(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/camchqtaccount/otsAuthApplyRequest", params, function(responseText){   
        if(responseText.code == "0000"){
          callback(responseText.content);
          console.log(responseText)
        }else{
          errBack();
          console.log(responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
        }
      }, function(err){
        errBack();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);
        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
    });
  }
}

//活期通加卡鉴权确认
export function addCardByHqtOk(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/camchqtaccount/otsAuthConfirm", params, function(responseText){   
        if(responseText.code == "0000"){
          callback(responseText.content);
          console.log(responseText)
        }else{
          errBack();
          console.log(responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
        }
      }, function(err){
        errBack();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);
        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);

    });
  }
}

//活期通加卡成功
export function addCardByHqtFinish(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/camchqtaccount/otsAddCardRequest", params, function(responseText){   
        if(responseText.code == "0000"){
          callback(responseText.content);
          console.log(responseText)
        }else{
          errBack();
          console.log(responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
        }
      }, function(err){
        errBack();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);

        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
    });
  }
}

//活期通开户加卡
export function addCardByHqtOpenFinish(params, callback, errBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/camchqtaccount/openOtsAccount", params, function(responseText){   
        if(responseText.code == "0000"){
          callback(responseText.content);
          console.log(responseText)
        }else{
          errBack();
          console.log(responseText.code);
          Toast.info(responseText.code, Util.ToastTime);
        }
      }, function(err){
        errBack();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);
        
      })
    })
    .catch( (err)=>{
      errBack();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
    });
  }
}

/*查询华夏基金用户是否存在以及获取用户信息/api/camchqtaccount/findCamcHqtExist*/
export const  hqtExist = (text)=>{
  return {
    type: 'HQT_EXIST',
    text
  }
}

export function findCamcHqtExist(data,callback){
  return function(dispatch, getState) {
      Util.get(Util.url+"/api/camchqtaccount/findCamcHqtExists",data,function(data){
        if(data.code == "0000"){
          dispatch(hqtExist(data.content));
          console.log(data,"查询华夏基金用户是否存在以及获取用户信息")
          if(callback){
              callback(data.content);
          }
        }else{
          // _this.setState({
          //   loadingFlag: false
          // })
          Toast.info(data.message, Util.ToastTime);
        }
      },function(error){
        // _this.setState({
        //     loadingFlag: false
        // })
        Toast.info(Util.errorTxt, Util.ToastTime);
      })
  }
}

/*/获取华夏财富活期通列表的接口 api/trade/getCwimUserHqtCard*/
export const getCwimUserHqtCard = (data)=>{
  console.log(data,"dafafdf")
  return new Promise((resolve,reject)=>{
      Util.get(Util.url+"/api/trade/getCwimUserHqtCard",data,function(result){
          if(result.code === '0000' && result.content){
           resolve(result.content) 
          }else{
            resolve([])
          }
      },function(error){
          reject('1111')
      })
  })
}


/*修改反洗钱信息 /api/camchqtaccount/modifyUserAccountInfo */
export function modifyUserAccount(params,callback){
  return function(dispatch, getState) {
      getTempInfo( 'shortToken' ).then((data) => {
        params.token = data;
        console.log(params,'反洗钱信息')
        Util.get(Util.url+"/api/camchqtaccount/modifyUserAccountInfo",params,function(res){
          console.log(data,'datadatadata')
          if(res.code == "0000"){
            Toast.info("添加反洗钱信息成功", Util.ToastTime);
            if(callback){
              callback(res)
            }
             dispatch(getUserInfoList())
          }else{
            // _this.setState({
            //   loadingFlag: false
            // })
            Toast.info(data.message, Util.ToastTime);
          }
        },function(error){
          // _this.setState({
          //     loadingFlag: false
          // })
          console.log(error)
          Toast.info(Util.errorTxt, Util.ToastTime);
        })
      })
  }
}
/*/api/camchqtaccount/modifyTaxInfo 修改税收信息*/
export function modifyTaxInfo(params,_this,callback){
  console.log(params,'修改税收信息')
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => {
      params.token = data;

      Util.get(Util.url+"/api/camchqtaccount/modifyTaxInfo",params,function(res){
        console.log(data,'datadatadata')
        if(res.code == "0000"){
          if(callback){
              callback(res.content);
          }
          dispatch(getUserInfoList());
        }else{
          _this.setState({
            flag: false
          })
          Toast.info(res.message, Util.ToastTime);
        }
      },function(error){
        _this.setState({
            flag: false
        })
        console.log(error)
        Toast.info(Util.errorTxt, Util.ToastTime);
      })
    })
  }
}


/*h5存数据*/
export const  shAlert = (text)=>{
  return {
    type: 'SH_ALERT_CONTENT',
    text
  }
}
/*活期通加卡存卡号*/
export const  htqAddCardNum = (text)=>{
  return {
    type: 'HQT_ADDCARD_NUM',
    text
  }
}






// WEBPACK FOOTER //
// ./src/action/myAssets/userInfoAction.js